// @flow

import { API_CALL } from '../constants/actionTypes';
import { COMPETITIONS_LIST, HALL_OF_FAME, ULTIMATE_CHALLENGE } from '../constants/apiTypes';

import { getCompetitionsList, getHallOfFame, getUltimateChallenge } from '../api/globalLeaderboard';

export function fetchUltimateChallenge(id: string) {
  return {
    type: API_CALL,
    api: ULTIMATE_CHALLENGE,
    request: getUltimateChallenge(id)
  };
}

export function fetchHallOfFame(id: string) {
  return {
    type: API_CALL,
    api: HALL_OF_FAME,
    request: getHallOfFame(id)
  };
}

export function fetchCompetitionsList() {
  return {
    type: API_CALL,
    api: COMPETITIONS_LIST,
    request: getCompetitionsList()
  };
}
